import { Routes } from '@angular/router';
import { AuthGuard } from '@core/guards/auth.guard';
import { agencyGuard } from '@core/guards/agency.guard';
import { AUTH_ROUTES } from './features/auth/auth.routes';
import { unsavedChangesGuard } from './features/forms/guards/unsaved-changes.guard';
import { provideNgxStripe } from 'ngx-stripe';
import { environment } from '@environments/environment';

export const routes: Routes = [
    ...AUTH_ROUTES,
    {
        path: '',
        loadComponent: () => import('./layout/main-layout/main-layout.component').then((m) => m.MainLayoutComponent),
        canActivate: [AuthGuard],
        children: [
            {
                path: '',
                redirectTo: 'home',
                pathMatch: 'full',
            },
            {
                path: 'home',
                loadComponent: () => import('./features/homepage/containers/home/home.component').then((m) => m.HomeComponent),
            },
            {
                path: 'campaigns',
                providers: [provideNgxStripe(environment.stripekey)],
                loadChildren: () => import('./features/campaigns/campaign.routes').then((m) => m.CAMPAIGN_ROUTES),
            },
            {
                path: 'profil',
                loadComponent: () => import('./features/profil/containers/profil/profil.component').then((m) => m.ProfilComponent),
            },
            {
                path: 'profil/agency/:clientId',
                loadComponent: () =>
                    import('./features/profil/containers/agency-client/agency-client.component').then((m) => m.AgencyClientComponent),
            },
            {
                path: 'crea',
                canActivate: [agencyGuard],
                loadComponent: () => import('./features/creator/containers/creator.component').then((m) => m.CreatorComponent),
            },
            {
                path: 'forms',
                canActivate: [agencyGuard],
                providers: [provideNgxStripe(environment.stripekey)],
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/forms/containers/forms/forms.component').then((m) => m.FormsComponent),
                        canDeactivate: [unsavedChangesGuard],
                    },
                ],
            },
            {
                path: 'data',
                canActivate: [agencyGuard],
                loadComponent: () => import('./features/data/containers/data/data.component').then((m) => m.DataComponent),
            },
            {
                path: 'help',
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./features/help/containers/help/help.component').then((m) => m.HelpComponent),
                    },
                    {
                        path: 'formats',
                        loadComponent: () => import('./features/help/containers/formats/format.component').then((m) => m.FormatComponent),
                    },
                    {
                        path: 'contact',
                        loadComponent: () => import('./features/help/containers/contact/contact.component').then((m) => m.ContactComponent),
                    },
                ],
            },
            {
                path: 'legal',
                loadChildren: () => import('./features/legal/legal.routes').then((m) => m.LEGAL_ROUTES),
            },
        ],
    },
    {
        path: '**',
        canActivate: [AuthGuard],
        loadComponent: () => import('./features/error/error.component').then((m) => m.ErrorComponent),
    },
];
